import { coreRouter } from "./coreRouter";

const router = [
  {
    meta: {
      icon: "iconfont iconjichuxinxiguanli",
      title: "微信机器人",
      uri: "/newRetail/weChatRobot",
    },
    subMenus: coreRouter,
  },
];

export default router;
